/* eslint-disable react/display-name */

import { EmotionJSX } from "@emotion/react/types/jsx-namespace"
import { Box } from "@mui/material"
import useProfile from "common/hooks/swr/useProfile"
import { Midnight } from "common/themes/colours"
import { useRouter } from "next/router"
import { useState } from "react"
import Icon from "../icon/icon"
import CollapseControl from "./CollapseControl"
import * as styles from "./NavigationSidebar.styles"
import RowItem from "./RowItem"

function iconComponent(name: string, color: string): () => EmotionJSX.Element {
    return () => <Icon name={name} color={color} size={16} width={16} />
}

export default function NavigationSidebar() {
    const { pathname, push } = useRouter()
    const [expanded, setExpanded] = useState(true)
    const profile = useProfile()

    const navigationEnabled = () =>
        (profile.data?.roles.isOnboardingAdmin ||
            profile.data?.roles.isOnboardingManager) ??
        false

    const navigate = (to: string) => {
        if (to !== pathname) push(to)
    }

    if (!navigationEnabled()) {
        return null
    }

    return (
        <Box css={styles.wrapper({ expanded })}>
            <Box css={styles.sidebarButtons}>
                <RowItem
                    name="Unit Tracker"
                    selected={pathname === "/"}
                    onClick={() => navigate("/")}
                    activeIconComponent={iconComponent("home", Midnight[100])}
                    inactiveIconComponent={iconComponent("home", Midnight[70])}
                    expanded={expanded}
                />

                <RowItem
                    name="Auto-Assign"
                    selected={pathname === "/auto-assign"}
                    onClick={() => navigate("/auto-assign")}
                    activeIconComponent={iconComponent(
                        "user-plus",
                        Midnight[100]
                    )}
                    inactiveIconComponent={iconComponent(
                        "user-plus",
                        Midnight[70]
                    )}
                    expanded={expanded}
                />
            </Box>

            <Box css={styles.control}>
                <CollapseControl
                    expanded={expanded}
                    onCollapse={() => setExpanded(false)}
                    onExpand={() => setExpanded(true)}
                />
            </Box>
        </Box>
    )
}
